import { FC, Suspense, useEffect } from 'react';
import { Skill } from '../../models/Skill';
import { Dialog } from 'primereact/dialog';
import { TeacherSingleSkill } from '../TeacherSingleSkill/TeacherSingleSkill';
import HorizontalLoading from '../../assets/HorizontalLoading/HorizontalLoading';
import { PreloadedQuery, useQueryLoader } from 'react-relay';
import { SkillsPresignedURLsQuery } from '../../graphQLOperations/__generated__/SkillsPresignedURLsQuery.graphql';
import { getPresignedURLsForSkill } from '../../graphQLOperations/Skills';

interface Props {
  skill: Skill;
  visible: boolean;
  setVisible: (v: boolean) => void;
}

const SingleUnitSkillDialog: FC<Props> = ({ skill, visible, setVisible }) => {
  const [skillsPresignedURLsQueryReference, loadSkillsPresignedURLsQuery] =
    useQueryLoader<SkillsPresignedURLsQuery>(getPresignedURLsForSkill);

  useEffect(() => {
    loadSkillsPresignedURLsQuery({
      skillCode: skill.code || '',
      filter: { storedObjectType: 'ALL' },
    });
  }, [skill]);

  return (
    <Dialog
      visible={visible}
      onHide={() => setVisible(false)}
      header={
        <h3>
          {skill.skillName} {skill.name} ({skill.code}) Skill Resources
        </h3>
      }
    >
      <Suspense fallback={<HorizontalLoading />}>
        {skillsPresignedURLsQueryReference && (
          <TeacherSingleSkill
            closeModalVersion={() => setVisible(false)}
            skillCode={skill.code}
            skill={skill}
            skillsPresignedURLsQueryReference={
              skillsPresignedURLsQueryReference as PreloadedQuery<SkillsPresignedURLsQuery, Record<string, unknown>>
            }
          />
        )}
      </Suspense>
    </Dialog>
  );
};

export default SingleUnitSkillDialog;
